 import { get } from 'lodash';
import { getDashboardBase } from 'src/util/helpers';
// @mui
import { useTheme } from '@mui/material/styles';
// import { Grid, Container, Typography, TableContainer, Table, TableBody, TableRow, TableCell, Avatar, TablePagination } from '@mui/material';
// components
import Page from '../../components/Page';
// sections
import { AppWidgetSummary } from '../../sections/@dashboard/app';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  deleteResult,
  exportAbsenteeList,
  exportMeritList,
  getAbsentList,
  getExamAverage,
  getExamDetail,
  getMeritList,
  marksChange,
  searchAbsenteeList,
  searchMeritList,
  sendSMSAbsenteeList,
  sendSMSMeritList,
} from 'src/axiosLib/services/exam/admin';
import Scrollbar from 'src/components/Scrollbar';
import { UserListHead, UserListToolbar } from 'src/sections/@dashboard/user';
import {
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  TextField,
} from '@mui/material';
// import { Stack } from '@mui/system';
// import Button from 'src/theme/overrides/Button';
import { Delete, Downloading, Edit, MoreVert, Visibility, PersonSearch, Image } from '@mui/icons-material';
import SearchNotFound from 'src/components/SearchNotFound';
import { DateTimePicker, LocalizationProvider } from '@mui/lab';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import config from '../../util/config';
import { adminLevel } from '../../axiosLib/services/institution/admin';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'roll', label: 'Roll', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  // { id: 'session', label: 'Session', alignRight: false },
  { id: 'central-rank', label: 'Central Rank', alignRight: false },
  { id: 'local-rank', label: 'Local Rank', alignRight: false },
  { id: 'Phone', label: 'Phone', alignRight: false },
  { id: 'marksGained', label: 'Marks Gained', alignRight: false },
  { id: 'institutionName', label: 'Institution', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: false },
];

const TABLE_HEAD_A = [
  { id: 'roll', label: 'Roll', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  // { id: 'session', label: 'Session', alignRight: false },
  { id: 'rank', label: 'Rank', alignRight: false },
  { id: 'Phone', label: 'Phone', alignRight: false },
  { id: 'gphone', label: 'Guardian SMS', alignRight: false },
  { id: 'instituteName', label: 'Institution', alignRight: false },
];

// ── Action Menu (3-in-1 dropdown) ──
function ActionMenu({ row, examDetails, handleMarksEdit }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [imgOpen, setImgOpen] = useState(false);
  const [imgSrc, setImgSrc] = useState('');
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const open = Boolean(anchorEl);

  const omrFileName = get(row, 'metaData.onlyFileName');

  const handleViewOmr = () => {
    setAnchorEl(null);
    setImgOpen(true);
    setImgSrc('');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    const token = localStorage.getItem('jwtToken');
    const axios = require('axios').default;

    axios
      .get(config.BASE_API_URL + '/webapi/institute/exam/omr-image/' + omrFileName, {
        headers: { Authorization: token },
        responseType: 'blob',
      })
      .then((res) => {
        const url = URL.createObjectURL(res.data);
        setImgSrc(url);
      })
      .catch((err) => {
        console.error('Failed to load OMR image', err);
      });
  };

  const handleCloseOmr = () => {
    setImgOpen(false);
    setImgSrc('');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  };

  const handleDeleteResult = () => {
    setDeleting(true);
    deleteResult(
      {
        examId: get(examDetails, '_id'),
        userId: get(row, 'userId._id'),
        resultId: get(row, '_id'),
      },
      (err, data) => {
        setDeleting(false);
        if (err) {
          alert('Failed to delete result');
        } else {
          setDeleteConfirm(false);
          window.location.reload();
        }
      }
    );
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          backgroundColor: '#880ED4',
          color: '#fff',
          fontWeight: 700,
          fontSize: '0.85rem',
          px: 2.5,
          py: 1,
          '&:hover': { backgroundColor: '#6a0dad' },
        }}
        endIcon={<MoreVert />}
      >
        Actions
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: { minWidth: 180, boxShadow: '0 8px 24px rgba(0,0,0,0.15)' },
        }}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            handleMarksEdit(row);
          }}
        >
          <ListItemIcon>
            <Edit fontSize="small" sx={{ color: '#880ED4' }} />
          </ListItemIcon>
          <ListItemText>Edit Marks</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            window.open(getDashboardBase() + '/register_student/?std=' + get(row, 'userId._id'), '_blank');
          }}
        >
          <ListItemIcon>
            <PersonSearch fontSize="small" sx={{ color: '#1976d2' }} />
          </ListItemIcon>
          <ListItemText>View Student</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            window.open(
              getDashboardBase() + '/checkUserGivenAnswers/?examId=' +
              get(examDetails, '_id', '') +
              '&userId=' +
              get(row, 'userId._id'),
              '_blank'
            );
          }}
        >
          <ListItemIcon>
            <Visibility fontSize="small" sx={{ color: '#800000' }} />
          </ListItemIcon>
          <ListItemText>View Answers</ListItemText>
        </MenuItem>
        {omrFileName && (
          <MenuItem onClick={handleViewOmr}>
            <ListItemIcon>
              <Image fontSize="small" sx={{ color: '#2e7d32' }} />
            </ListItemIcon>
            <ListItemText>View OMR Sheet</ListItemText>
          </MenuItem>
        )}
        <Divider />
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setDeleteConfirm(true);
          }}
          sx={{ color: '#dc3545' }}
        >
          <ListItemIcon>
            <Delete fontSize="small" sx={{ color: '#dc3545' }} />
          </ListItemIcon>
          <ListItemText>Delete Result</ListItemText>
        </MenuItem>
      </Menu>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteConfirm}
        onClose={() => setDeleteConfirm(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700, color: '#dc3545' }}>
          ⚠ Delete Result
        </DialogTitle>
        <DialogContent>
          <div style={{ fontSize: '1rem', lineHeight: 2 }}>
            <div>Are you sure you want to <strong style={{ color: '#dc3545' }}>permanently delete</strong> this result?</div>
            <div style={{ marginTop: 12, backgroundColor: '#f8f9fa', borderRadius: 8, padding: 16 }}>
              <div><strong>Exam:</strong> {get(examDetails, 'name', '')}</div>
              <div><strong>Student:</strong> {get(row, 'userId.username', '')}</div>
              <div><strong>Roll:</strong> {get(row, 'userId.roll', '')}</div>
              <div><strong>Phone:</strong> {get(row, 'userId.phone', 'N/A')}</div>
              <div><strong>Marks:</strong> {get(row, 'totalMarksGained', '')}</div>
              <div><strong>Rank:</strong> {get(row, 'rank', '')}</div>
            </div>
            <div style={{ marginTop: 12, color: '#666', fontSize: '0.9rem' }}>
              This will remove the result from merit list, enrollment records, and clear the leaderboard cache.
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={() => setDeleteConfirm(false)}
            variant="outlined"
            sx={{ px: 3 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteResult}
            variant="contained"
            disabled={deleting}
            sx={{
              backgroundColor: '#dc3545',
              px: 3,
              fontWeight: 700,
              '&:hover': { backgroundColor: '#b02a37' },
            }}
          >
            {deleting ? 'Deleting...' : 'Yes, Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* OMR Image Modal */}
      {imgOpen && (
        <div
          onClick={handleCloseOmr}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 99999,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#000',
              borderRadius: 12,
              boxShadow: '0 24px 80px rgba(0,0,0,0.4)',
              maxWidth: '90vw',
              maxHeight: '80vh',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            {/* Header */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 20px',
                borderBottom: '1px solid #333',
              }}
            >
              <div>
                <div style={{ fontSize: '1rem', fontWeight: 700, color: '#fff' }}>
                  {get(row, 'userId.username', '')} — Roll: {get(row, 'userId.roll', '')}
                </div>
                <div style={{ fontSize: '0.85rem', color: '#aaa' }}>
                  Phone: {get(row, 'userId.phone', 'N/A')}
                </div>
              </div>
              <Button
                onClick={handleCloseOmr}
                variant="contained"
                sx={{
                  backgroundColor: '#dc3545',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: '0.95rem',
                  px: 3,
                  py: 1,
                  '&:hover': { backgroundColor: '#b02a37' },
                }}
              >
                Close
              </Button>
            </div>

            {/* Image */}
            <div style={{ padding: 16, textAlign: 'center', overflow: 'auto' }}>
              {!imgSrc && (
                <div style={{ padding: 40, color: '#888' }}>Loading image...</div>
              )}
              {imgSrc && (
                <img
                  src={imgSrc}
                  alt="OMR Sheet"
                  style={{
                    maxWidth: '100%',
                    maxHeight: 'calc(75vh - 80px)',
                    objectFit: 'contain',
                    borderRadius: 4,
                  }}
                />
              )}
            </div>

            {/* Footer */}
            {imgSrc && (
              <div
                style={{
                  padding: '12px 20px',
                  borderTop: '1px solid #333',
                  textAlign: 'center',
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => {
                    const a = document.createElement('a');
                    a.href = imgSrc;
                    a.download = omrFileName || 'omr-sheet.jpg';
                    a.click();
                  }}
                  sx={{
                    fontWeight: 700,
                    fontSize: '0.95rem',
                    px: 4,
                    py: 1,
                  }}
                  startIcon={<Downloading />}
                >
                  Download
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default function ExamResult() {
  const theme = useTheme();
  const navigate = useNavigate();

  const [avgMarks, setAvgMarks] = useState(0);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const examId = urlParams.get('examId');

  const [exam, setExam] = useState();

  const [leaderboard, setLeaderboard] = useState([]);
  const [examSubmitted, setExamSubmitted] = useState(0);
  const [leaderboardPage, setLeaderboardPage] = useState(0);
  const [leaderboardRowsPerPage, setLeaderboardRowsPerPage] = useState(10);
  const [hightestMarks, setHightestMarks] = useState(0);
  const [editable, setEditable] = useState(false);

  const [subjectModal, setSubjectModal] = useState(false);
  const [absentModal, setAbsentModal] = useState(false);

  const [absentBoardPage, setAbsentBoardPage] = useState(0);
  const [absentBoardRowsPerPage, setAbsentboardRowsPerPage] = useState(10       );

  const [filterNameLeaderboard, setFilterNameLeaderBoard] = useState('');
  const [filterNameAbsent, setFilterNameAbsent] = useState('');

  const [absentBoard, setAbsentBoard] = useState([]);
  const [examMissed, setExamMissed] = useState(0);

  const [enrolledData, setEnrolledData] = useState(0);

  const [totals, setTotals] = useState(0);
  const [submittedS, setSubmittedS] = useState(0);

  const [marksModal, setMarksModal] = useState(false);
  const [marksData, setMarksData] = useState({});

  const [examDetails, setExamDetails] = useState({});

  const isUserNotFound = leaderboard.length === 0;

  const avgScore = () => {
    try {
      getExamAverage(examId, (error, data) => {
        if (!error) {
          setAvgMarks(data);
        } else {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getExamDetailsInfo = () => {
    try {
      adminLevel((error, admData) => {
        getExamDetail(examId, (error, data) => {
          if (!error) {
            setExam(data);
            // console.log(data);

            setEditable(
              get(data, 'institutionId._id', 'X').toString() === get(admData, 'admin.institutionId._id', 'Y')
            );
          } else {
            console.log(error);
          }
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getLeaderboard = () => {
    try {
      getMeritList(examId, leaderboardRowsPerPage, leaderboardPage, (error, data) => {
        if (!error) {
          setLeaderboard(data.leaderboard);
          setExamSubmitted(data.size);
          setTotals(data.size);
          setEnrolledData(data.size);
          // console.log(data.size);
          setHightestMarks(get(data, 'leaderboard[0].totalMarksGained', 0));
        } else {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getAbsentBoard = () => {
    try {
      getAbsentList(examId, absentBoardRowsPerPage, absentBoardPage, (error, data) => {
        if (!error) {
          setAbsentBoard(data.absent);
          setExamMissed(data.size);
          setSubmittedS(data.size);
        } else {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const sendSmsToMerit = () => {
    setSubjectModal(false);

    sendSMSMeritList(examId, enrolledData, (error, data) => {
      if (!error) {
        alert('SMS SENT SUCCESS ');
      } else {
        alert(error.msg);
      }
    });
  };

  const sendSmsToAbsent = () => {
    setAbsentModal(false);

    sendSMSAbsenteeList(examId, (error, data) => {
      if (!error) {
        alert('SMS SENT SUCCESS');
      } else {
        alert(error.msg);
      }
    });
  };

  const handleEnrollmentChange = (fieldName, event) => {
    setEnrolledData(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setLeaderboardPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLeaderboardRowsPerPage(event.target.value);
    setLeaderboardPage(0);
  };

  const handleFilterByName = (event) => {
    setLeaderboardPage(0);
    setLeaderboardRowsPerPage(5);
    setFilterNameLeaderBoard(event.target.value);
  };

  const handleMarksDataChange = (fieldName, event) => {
    // console.log(event.target.value);
    setMarksData({ ...marksData, [fieldName]: event.target.value });
  };

  const handleChangePageA = (event, newPage) => {
    setAbsentBoardPage(newPage);
  };

  const handleChangeRowsPerPageA = (event) => {
    setAbsentboardRowsPerPage(event.target.value);
    setAbsentBoardPage(0);
  };

  const handleFilterByNameA = (event) => {
    setAbsentBoardPage(0);
    setAbsentboardRowsPerPage(5);
    setFilterNameAbsent(event.target.value);
  };

  useEffect(() => {
    avgScore();
    getExamDetailsInfo();
    // getLeaderboard();
    // getAbsentBoard();
  }, []);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const examId = urlParams.get('examId');

    getExamDetail(examId, (err, data) => {
      if (!err) {
        setExamDetails(data);
      }
    });
  }, []);

  const downloadExcelMerit = () => {
    const studentData = {
      sortOrder: {
        score: 0,
        name: 0,
        roll: 1,
        rank: 1,
        participatedAt: 0,
      },
    };

    exportMeritList(studentData, examId, (error, data) => {
      if (!error) {
        var XLSX = require('xlsx');
        const worksheet = XLSX.utils.json_to_sheet(data.excel);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, data.name + '.xlsx');
      } else {
        console.log(error);
      }
    });
  };

  const handleMarksEdit = (row) => {
    const temp = {
      _id: get(row, '_id', ''),
      marks: get(row, 'totalMarksGained', 0),
      prevMarks: get(row, 'totalMarksGained', 0),
      name: get(row, 'userId.username', ''),
    };

    setMarksData(temp);

    setMarksModal(true); //
  };

  const editMarks = () => {
    console.log(marksData);

    marksChange(marksData, (error, data) => {
      if (!error) {
        // console.log(data);

        window.location.reload(false);
      } else {
        alert(error);
      }
    });
  };

  const downloadExcelAbsent = () => {
    const studentData = {
      sortOrder: {
        score: 0,
        name: 0,
        roll: 1,
        rank: 0,
        participatedAt: 0,
      },
    };

    exportAbsenteeList(studentData, examId, (error, data) => {
      if (!error) {
        var XLSX = require('xlsx');
        const worksheet = XLSX.utils.json_to_sheet(data.excel);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, data.name + '.xlsx');
      } else {
        console.log(error);
      }
    });
  };

  useEffect(() => {
    // console.log(leaderboardPage);
    getLeaderboard();
  }, [leaderboardPage, leaderboardRowsPerPage]);

  useEffect(() => {
    getAbsentBoard();
  }, [absentBoardPage, absentBoardRowsPerPage]);

  useEffect(() => {
    if (filterNameLeaderboard.length > 0) {
      searchMeritList(
        examId,
        { string: filterNameLeaderboard || '', limit: leaderboardRowsPerPage || 5 },
        (error, data) => {
          if (!error) {
            setLeaderboard(data.array);
            setExamSubmitted(data.size);
          } else {
            console.log(error);
          }
        }
      );
    }
  }, [filterNameLeaderboard]);

  useEffect(() => {
    if (filterNameAbsent.length > 0)
      searchAbsenteeList(
        examId,
        { string: filterNameAbsent || '', limit: absentBoardRowsPerPage || 5 },
        (error, data) => {
          if (!error) {
            setAbsentBoard(get(data, 'absent', []));
            setExamMissed(get(data, 'size', 0));
          } else {
            console.log(error);
          }
        }
      );
  }, [filterNameAbsent]);

  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Average Marks" total={avgMarks} icon={'subway:sms-3'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Hightest Marks" total={hightestMarks} color="info" icon={'fa6-solid:users-rays'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Total Submitted ONLINE + OFFLINE"
              total={examSubmitted}
              color="warning"
              icon={'mdi:register'}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Student Attended in %"
              total={(totals / (totals + submittedS)) * 100}
              color="error"
              icon={'mdi:server-security'}
            />
          </Grid>
        </Grid>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={10}>
          {' '}
        </Stack>

        <Card sx={{ width: '98%', marginBottom: '30px', border: '2px solid #800000' }}>
          <CardContent
            style={{
              backgroundColor: 'beige',
              color: '#800000',
              fontWeight: 'bold',
              fontSize: '20px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            Exam Details | CODE: {get(examDetails, 'code', '')}
          </CardContent>
        </Card>

        <Card sx={{ width: '98%', marginBottom: '30px', border: '2px solid #800000' }}>
          <CardContent
            style={{
              backgroundColor: 'beige',
              color: '#800000',
              fontWeight: 'bold',
              fontSize: '20px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Button
                  variant="contained"
                  style={{ backgroundColor: '#800000', color: 'white', padding: '10px 40px', marginRight: '10px' }}
                  onClick={() => {
                    let link =
                      config.WEB_LINK +
                      'printExam/?examId=' +
                      get(examDetails, '_id', '') +
                      '&fontSize=12px&set=A&questionNumbers=12:25:37:50';

                    console.log(link);

                    window.open(link, '_blank');
                  }}
                >
                  Print Exam
                </Button>
              </Stack>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Button
                  style={{ backgroundColor: '#800000', color: 'white', padding: '10px 40px', marginRight: '10px' }}
                  onClick={() => {
                    let link = config.WEB_LINK + 'reg/publicExam?examId=' + get(examDetails, '_id', '');

                    alert(link);
                  }}
                >
                  Public Exam Link
                </Button>
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Button
                  variant="contained"
                  component={RouterLink}
                  to={
                    getDashboardBase() + '/qrGeneratorPage/?preLoadedLink=' +
                    'examCode=' +
                    get(examDetails, 'code', '')
                  }
                  style={{ backgroundColor: '#800000', color: 'white', padding: '10px 40px', marginRight: '10px' }}
                >
                  QR Code Exam Link
                </Button>
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Button
                  style={{ backgroundColor: '#800000', color: 'white', padding: '10px 40px' }}
                  onClick={() => {
                    let link = config.WEB_LINK + getDashboardBase().substring(1) + '/editExam/?examId=' + get(examDetails, '_id', '');

                    window.open(link, '_blank');
                  }}
                >
                  Edit Exam
                </Button>
              </Stack>
            </div>
          </CardContent>
        </Card>

        <div
          style={{
            width: '98%',
            marginBottom: '30px',
            border: '2px solid #800000',
            padding: '25px 10px',
            borderRadius: '20px',
          }}
        >
          <Stack spacing={3}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                name="name"
                label="Exam Name"
                value={get(examDetails, 'name', '')}
                style={{ width: '100%' }}
                disabled={true}
              />
            </Stack>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                name="numberOfQuestions"
                label="Total Questions"
                value={get(examDetails, 'numberOfQuestions', '')}
                style={{ width: '100%' }}
                disabled={true}
              />

              <TextField
                name="marksPerQuestion"
                label="Marks Per Question"
                value={get(examDetails, 'marksPerQuestion', '')}
                style={{ width: '100%' }}
                disabled={true}
              />

              <TextField
                name="negativeMarks"
                label="Negative Marks Per Question"
                value={get(examDetails, 'negativeMarks', '')}
                style={{ width: '100%' }}
                disabled={true}
              />

              <TextField
                name="duration"
                label="Exam Duration in Minutes"
                value={get(examDetails, 'duration', '')}
                style={{ width: '100%' }}
                disabled={true}
              />

              <TextField
                name="teacher"
                label="Teacher"
                value={get(examDetails, 'teacher', '')}
                style={{ width: '100%' }}
                disabled={true}
              />

              <TextField
                name="session"
                label="Session"
                value={get(examDetails, 'session', '')}
                style={{ width: '100%' }}
                disabled={true}
              />
            </Stack>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs} style={{ width: '100%' }}>
                <DateTimePicker
                  label="Exam START Time"
                  name="startTime"
                  value={moment(get(examDetails, 'startTime')).format('yyyy-MM-DD hh:mm A')}
                  inputFormat="DD/MM/YYYY hh:mm A"
                  renderInput={(params) => <TextField {...params} />}
                  PopperProps={{
                    style: { zIndex: 10001 },
                  }}
                  disabled={true}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs} style={{ width: '100%' }}>
                <DateTimePicker
                  label="Exam END Time"
                  name="endTime"
                  value={moment(get(examDetails, 'endTime')).format('yyyy-MM-DD hh:mm A')}
                  inputFormat="DD/MM/YYYY hh:mm A"
                  renderInput={(params) => <TextField {...params} />}
                  style={{ width: '100%' }}
                  PopperProps={{
                    style: { zIndex: 10001 },
                  }}
                  disabled={true}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs} style={{ width: '100%' }}>
                <DateTimePicker
                  label="ANSWER Publish Time"
                  name="answerPublishTime"
                  value={moment(get(examDetails, 'answerPublishTime')).format('yyyy-MM-DD hh:mm A')}
                  inputFormat="DD/MM/YYYY hh:mm A"
                  renderInput={(params) => <TextField {...params} />}
                  PopperProps={{
                    style: { zIndex: 10001 },
                  }}
                  disabled={true}
                />
              </LocalizationProvider>
            </Stack>
          </Stack>
        </div>

        <Card>
          {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={10}> </Stack> */}
          <Stack direction="row" alignItems="center" justifyContent="space-around" spacing={5}>
            <Card sx={{ width: '25%', marginBottom: '30px', border: '2px solid #800000' }}>
              <CardContent
                style={{
                  backgroundColor: 'beige',
                  color: '#800000',
                  fontWeight: 'bold',
                  fontSize: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                Merit List
              </CardContent>
            </Card>
            <UserListToolbar filterName={filterNameLeaderboard} onFilterName={handleFilterByName} />
            {editable ? (
              <Button
                variant="contained"
                onClick={(e) => setSubjectModal(true)}
                style={{ color: 'white', backgroundColor: '#d53624', width: '30%', marginRight: 15 }}
              >
                <Downloading style={{ color: 'white', marginRight: 5 }} />
                SEND SMS TO MERIT LIST
              </Button>
            ) : (
              <div></div>
            )}

            <Button
              variant="contained"
              onClick={(e) => {
                downloadExcelMerit();
              }}
              style={{ color: 'white', backgroundColor: 'blue', width: '20%', marginRight: 15 }}
            >
              <Downloading style={{ color: 'white', marginRight: 5 }} />
              DOWNLOAD
            </Button>
          </Stack>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  // order={order}
                  // orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={leaderboard.length}
                />
                <TableBody>
                  {leaderboard.map((row, i) => {
                    return (
                      <TableRow hover key={get(row, '_id', '')} tabIndex={-1}>
                        <TableCell align="left"> {get(row, 'userId.roll', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'userId.username', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'rank', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'instituteWiseRank', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'userId.phone', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'totalMarksGained', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'userId.institutionId.institutionName', '')}</TableCell>

                        <TableCell align="left">
                          <ActionMenu
                            row={row}
                            examDetails={examDetails}
                            handleMarksEdit={handleMarksEdit}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        {/* <SearchNotFound searchQuery={filterNameLeaderboard} /> */}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={examSubmitted}
            rowsPerPage={leaderboardRowsPerPage}
            page={leaderboardPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={10}>
          {' '}
        </Stack>
        <Card>
          <Stack direction="row" alignItems="center" justifyContent="space-around" spacing={5}>
            <Card sx={{ width: '25%', marginBottom: '30px', border: '2px solid #800000' }}>
              <CardContent
                style={{
                  backgroundColor: 'beige',
                  color: '#800000',
                  fontWeight: 'bold',
                  fontSize: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                Absent List
              </CardContent>
            </Card>
            <UserListToolbar filterName={filterNameAbsent} onFilterName={handleFilterByNameA} />
            {editable ? (
              <Button
                variant="contained"
                onClick={(e) => setAbsentModal(true)}
                style={{ color: 'white', backgroundColor: '#d53624', width: '30%', marginRight: 15 }}
              >
                <Downloading style={{ color: 'white', marginRight: 5 }} />
                SEND SMS TO ABSENT LIST
              </Button>
            ) : (
              <div></div>
            )}

            <Button
              variant="contained"
              onClick={(e) => {
                downloadExcelAbsent();
              }}
              style={{ color: 'white', backgroundColor: 'blue', width: '20%', marginRight: 15 }}
            >
              <Downloading style={{ color: 'white', marginRight: 5 }} />
              DOWNLOAD
            </Button>
          </Stack>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead headLabel={TABLE_HEAD_A} rowCount={absentBoard.length} />
                <TableBody>
                  {absentBoard.map((row, i) => {
                    return (
                      <TableRow hover key={get(row, '_id', '')} tabIndex={-1}>
                        <TableCell align="left"> {get(row, 'roll', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'username', '')}</TableCell>
                        <TableCell align="left"> ABSENT</TableCell>
                        <TableCell align="left"> {get(row, 'phone', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'guardianSMS', '')}</TableCell>
                        <TableCell align="left"> {get(exam, 'institutionId.institutionName', '')}</TableCell>
                        <TableCell align="left">
                          {' '}
                          {
                            <Button
                              variant="contained"
                              component={RouterLink}
                              to={getDashboardBase() + '/register_student/?std=' + get(row, '_id')}
                            >
                              VIEW STUDENT
                            </Button>
                          }
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterNameAbsent} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={examMissed}
            rowsPerPage={absentBoardRowsPerPage}
            page={absentBoardPage}
            onPageChange={handleChangePageA}
            onRowsPerPageChange={handleChangeRowsPerPageA}
          />
        </Card>

        <div>
          <Dialog open={subjectModal} onClose={(e) => setSubjectModal(false)}>
            <DialogTitle>Send SMS to Merit List?</DialogTitle>

            <DialogContent>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                {' '}
              </Stack>
              <TextField
                name="name"
                label="Total Exam Given (Editable)"
                style={{ width: '100%' }}
                value={enrolledData}
                onChange={(e) => {
                  handleEnrollmentChange('enrolled', e);
                }}
                required
              />
            </DialogContent>

            <DialogActions>
              <Button
                variant="contained"
                onClick={(e) => setSubjectModal(false)}
                style={{ color: 'white', backgroundColor: 'red' }}
              >
                CANCEL
              </Button>
              <Button variant="contained" onClick={sendSmsToMerit} style={{ color: 'white', backgroundColor: 'blue' }}>
                SEND
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        <div>
          <Dialog open={absentModal} onClose={(e) => setAbsentModal(false)}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              {' '}
            </Stack>
            <DialogTitle>Send SMS to Absent List?</DialogTitle>

            <DialogActions>
              <Button
                variant="contained"
                onClick={(e) => setAbsentModal(false)}
                style={{ color: 'white', backgroundColor: 'red' }}
              >
                CANCEL
              </Button>
              <Button variant="contained" onClick={sendSmsToAbsent} style={{ color: 'white', backgroundColor: 'blue' }}>
                SEND
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        {/* MARKS MODAL*/}
        <div>
          <Dialog open={marksModal} onClose={() => setMarksModal(false)}>
            <DialogTitle>Edit Marks</DialogTitle>
            <DialogTitle>{get(marksData, 'name', '')}</DialogTitle>
            <DialogTitle>Current Marks: {get(marksData, 'prevMarks', '')}</DialogTitle>

            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              {' '}
            </Stack>
            <DialogContent>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  name="marks"
                  label="New Total Marks"
                  style={{ width: '100%' }}
                  value={get(marksData, 'marks', '')}
                  onChange={(e) => {
                    handleMarksDataChange('marks', e);
                  }}
                  required
                />
              </Stack>
            </DialogContent>

            <DialogActions>
              <Button variant="contained" onClick={editMarks} style={{ color: 'white', backgroundColor: 'blue' }}>
                ADD / EDIT
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Container>
    </Page>
  );
}
